var $ = global.jQuery = global.$;
var _Base = require('./_Base');
var loadingTpl = require('../templates/loading.dot');

/**
 * Track CSS properties
 * @class
 * @extends _Base
 */
var Loading = _Base.extend(
  /** @lends Loading.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;

    this.$loadContent = this.$el.find('[data-load-content]');

    this.messageLoading = this.$el.data('messageLoading') || 'Loading...';
    this.messageFailed = this.$el.data('messageFailed') || 'Something went wrong, please try again later';


    this.showMessage(this.messageLoading);

    this.$el.on('Loading:Success', function(event) {
      setTimeout(function() {
        self.killMessage();
      }, 300);
    });
    this.$el.on('Loading:Failed', function(event, message) {
      message = message || self.messageFailed;
      self.showMessage(message);
    });
    this.$el.on('Loading:Start', function(event, message) {
      self.showMessage(message);
    });
  },
  showMessage: function(message) {
    var existingMessage = typeof this.$message !== 'undefined';
    this.$el.css({
      position: 'relative'
    });
    this.initialContentHeight = this.$loadContent.height();

    this.$el.height(this.$el.height());
    this.$loadContent.addClass('is-loading');
    this.$loadContent.css({
      opacity: '0'
    });
    if (existingMessage) this.$message.remove();
    this.$message = $(loadingTpl(message));
    if (!existingMessage) {
      this.$message.css({
        opacity: '0'
      });
    }
    this.$el.append(this.$message);
    if (!existingMessage) {
      this.$message.velocity('fadeIn');
    }
  },
  killMessage: function() {
    var self = this;
    var newHeight = this.$el.height() + this.$loadContent.height() - this.initialContentHeight;
    self.$el.velocity({
      'height': newHeight
    });
    self.$loadContent.velocity('fadeIn');
    this.$message.velocity('fadeOut',{
      complete: function() {
        self.$el.removeAttr('style');
        self.$loadContent.removeClass('is-loading');
      }
    });
  }
});

module.exports = Loading;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/Loading.js
// module id = 68
// module chunks = 0